// Module
var code = "<div class=\"form-input-percentage input-percentage\"> <input id=\"vm.id\" class=\"form-control form-linear-grad\" ng-model=\"vm.model\" ng-blur=\"vm.onBlur({ value: vm.model })\" ng-change=\"vm.onChange({ value: vm.model })\"/> </div> ";
// Exports
module.exports = code;